import React, {useState, useEffect, Fragment} from 'react';
import emailjs from 'emailjs-com';
import ReCaptchaV2 from "react-google-recaptcha";
 
const NuestraRedForm = () => {
   const frmContact = { nombre:'', apellido:'', matricula:'', oficina: '', codarea:'' ,tel:'', email:'', localidad:''};
   const [contact,setContact] = useState(frmContact);
   const [showMessage, setShowMessage] = useState(false);
 

   const handleToken = (token) => {
	 setContact((currentForm) => {
	 return {...currentForm, token }
	})
  }

  const handleExpire = () => {
	setContact((currentForm) => {
	 return {...currentForm, token: null }
	})
  }

   const handleChange = e => { 
		const {name,value} = e.target;
		setContact({...contact,[name]:value}); 
   };

   const handleChangeRadio = e => { 
		const {name,value} = e.target;
		setContact({...contact,[name]:value}); 
	};
   useEffect(() => {
	window.scrollTo(0, 0)
   }, [])

   const handleSubmit = e =>{
	    e.preventDefault();

		emailjs.send('default_service','template_lkbaotp', contact, 'user_gjB2OcgTfvhXOG5nEPbcj')
		.then((response) => {
				   console.log('SUCCESS!', response.status, response.text);
				   setContact(frmContact);
				   setShowMessage(true);
				   window.scrollTo(0, 0);
		}, (err) => {
				   console.log('FAILED...', err);
		});
   }

  return (
    <div style={{'padding-bottom': '5%'}} className="container pt-2 text-center col-md-10">

		<div className="alert alert-light" role="alert">
		      
		</div>
		
		{ showMessage ? <div className="alert alert-success col-md-7 mx-auto" role="alert">Solicitud Enviada!!</div> : ``}
	
		<form onSubmit={handleSubmit} style={{color: 'rgb(150, 152, 154)'}}>
			<div className="row col-md-7 mx-auto">
				<h3 className="font-weight-bold container"> Sumate a nuestra Red</h3>		 
				
						<div  style={{margin: '0% 0% 5% 0%'}} className="text-secondary"> Para poder comenzar el proceso de incorporación a ART Mutual Rural, unite a nuestra organización de productores de seguros en todo el país, por favor, dejanos tus datos:</div> 
				

						<div className="text-left mx-auto"> <b>Nombre<b style={{color: 'red'}}> * </b></b> <br/>
							<input value={contact.nombre} required type="text" name="nombre" onChange={handleChange}  className="input-group form-control" placeholder="Nombre" />
						</div>

						<div className="text-left mx-auto"> <b>Apellido <b style={{color: 'red'}}> * </b></b> <br/>
							<input value={contact.apellido} required type="text" name="apellido" onChange={handleChange}  className="input-group form-control" placeholder="Apellido" />
						</div>
			  </div>

			<br/>	
			  <div className="row col-md-7 mx-auto">
			  		<div className="text-left mx-auto"> <b>Matricula de PAS<b style={{color: 'red'}}> * </b></b> <br/>
						<input value={contact.matricula} required type="text" name="matricula" onChange={handleChange}  className="input-group form-control" placeholder="Matricula" />
					</div>
					
					<div className="text-left mx-auto" onChange={handleChangeRadio}> <b>Tiene Oficina Comercial?</b> <br/>
						<div className="row center" style={{'justify-content': 'space-evenly'}}> 
							<div >
								<input type="radio" value="si" name="oficina"/> Si
							</div>
							<div>
								<input type="radio" value="no" name="oficina"/> No
							</div>
						</div>	
					</div>
				</div>
				<br/>
			  <div className="row col-md-7 mx-auto">
					<div  className="text-left mx-auto"> <b>Cod.Área<b style={{color: 'red'}}>*</b></b> <br/>
						<input value={contact.codarea} required type="text" name="codarea" onChange={handleChange}  className="input-group form-control" placeholder="Cod.Área" />
					</div>

					<div className="text-left mx-auto"> <b>Teléfono <b style={{color: 'red'}}> * </b></b> <br/>
						<input value={contact.tel} required type="text" name="tel" onChange={handleChange}  className="input-group form-control" placeholder="Telefono" />
					</div>
			  </div>

			  <div className="pt-3 col-md-6 mx-auto"> <b>Correo Electrónico <b style={{color: 'red'}}> * </b></b> <br/>
					<input value={contact.email} required type="email" name="email" onChange={handleChange}  className="input-group form-control" placeholder="Email" />
			  </div>

			  <div className="pt-3 col-md-6 mx-auto">
					<b>Localidad<b style={{color: 'red'}}> * </b></b><br/>
					<input value={contact.localidad} required type="text" name="localidad" onChange={handleChange}  className="input-group form-control" placeholder="Localidad" />
			  </div>

				<div style={{display:'inline-block'}}>
					<ReCaptchaV2 
						sitekey="6Le2BN4aAAAAAAmszeHqg7NmclYXPoaqC0PXoypW"
						onChange={handleToken}
						onExpire={handleExpire}
					/>
				</div>	
			  <div className="pt-3 mx-auto text-center">
					<button className="btn btn-primary btn-enviar">Enviar</button>
			  </div>
		</form>	
	</div>
  );
}
export default NuestraRedForm;
